export class Schedule {
    StartDate?: Date;
    EndDate?: Date;

    constructor(){
       
    }
}